module.exports = __webpack_public_path__ + "static/txtling1-9691280a55cb841885740d3ced8f6172.png";